module.exports = __webpack_public_path__ + "static/bg.368e612d.png";